const BASE = '/api/user-content';

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('accessToken');
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: authHeaders(),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).error || `Erro ${res.status}`);
  }
  return res.json();
}

// ── Collections ──────────────────────────────────────────────────────────────

export const getCollections = () => request<any[]>('GET', '/collections');

export const createCollection = (data: { name: string; description?: string; colorId?: string; icon?: string }) =>
  request<any>('POST', '/collections', data);

export const updateCollection = (id: string, data: { name?: string; description?: string; colorId?: string; icon?: string }) =>
  request<any>('PUT', `/collections/${id}`, data);

export const deleteCollection = (id: string) =>
  request<any>('DELETE', `/collections/${id}`);

export const reorderCollections = (items: { _id: string; order: number }[]) =>
  request<any>('PUT', '/collections/reorder', { items });

// ── Decks ────────────────────────────────────────────────────────────────────

export const getDecks = (colId: string) =>
  request<any[]>('GET', `/collections/${colId}/decks`);

export const createDeck = (colId: string, data: { name: string; description?: string; colorId?: string }) =>
  request<any>('POST', `/collections/${colId}/decks`, data);

export const updateDeck = (id: string, data: { name?: string; description?: string; colorId?: string }) =>
  request<any>('PUT', `/decks/${id}`, data);

export const deleteDeck = (id: string) =>
  request<any>('DELETE', `/decks/${id}`);

export const reorderDecks = (items: { _id: string; order: number }[]) =>
  request<any>('PUT', '/decks/reorder', { items });

// ── Cards (direto no deck) ───────────────────────────────────────────────────

export const getDeckCards = (deckId: string) =>
  request<{ deckName: string; subdeck: any }>('GET', `/decks/${deckId}/cards`);
